// extracted by mini-css-extract-plugin
export default {"outlet":"[userId]_outlet__ZXy9t","title":"[userId]_title__N26aH"};